module.exports = __webpack_public_path__ + "img/picture_23.45893e5f.png";